import { Box, Typography } from '@mui/material'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import { COLORS, SITE } from '../../constants'
import Section from './Section'
import TvButton from './TvButton'

type CtaBannerProps = {
    title?: string
    body?: string
    buttonText?: string
    to?: string
}

/** Closing call-to-action used at the bottom of most pages. */
function CtaBanner({
    title = 'Tell me what you’re trying to build.',
    body = 'Or what’s annoying, expensive, repetitive, or broken. A short description is plenty. I’ll reply and we can figure out whether software can fix it.',
    buttonText = 'Start a Project',
    to = '/contact',
}: CtaBannerProps) {
    return (
        <Section tone="dark">
            <Box sx={{ display: 'grid', gap: 4, gridTemplateColumns: { xs: '1fr', md: '1.4fr 1fr' }, alignItems: 'center' }}>
                <Box>
                    <Typography variant="overline" component="p" sx={{ color: COLORS.accent, mb: 1 }}>
                        {SITE.manualTagline} {SITE.manualPunchline}
                    </Typography>
                    <Typography variant="h2">{title}</Typography>
                    <Typography sx={{ mt: 2, color: COLORS.mutedOnDark, maxWidth: 560 }}>{body}</Typography>
                </Box>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1.5, justifyContent: { md: 'flex-end' } }}>
                    <TvButton text={buttonText} to={to} size="large" icon={<ArrowForwardIcon />} />
                    <TvButton text="Email me" link={`mailto:${SITE.email}`} variant="outline" tone="dark" size="large" />
                </Box>
            </Box>
        </Section>
    )
}

export default CtaBanner
